import { render, staticRenderFns } from "./EventItineraryRatingTable.vue?vue&type=template&id=4fab702b"
import script from "./EventItineraryRatingTable.vue?vue&type=script&lang=js"
export * from "./EventItineraryRatingTable.vue?vue&type=script&lang=js"
import style0 from "./EventItineraryRatingTable.vue?vue&type=style&index=0&id=4fab702b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports